import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { TeamRequest } from '../../shared/models/team-request';
import { TeamRequestTypes } from '../../shared/models/team-request-types';
import { OrganisationUnit } from '../../shared/models/organisation-unit';
import { ApprovalUser } from '../../shared/models/approval-user';
import { Team } from '../../shared/models/team';
import { AuthenticationProvider } from '../providers/authentication.provider';
import { User } from '../../shared/models/user';
import { Plant } from '../../shared/models/plant';

@Injectable({
  providedIn: 'root'
})
export class TeamRequestService {

  private Api_URL: string = environment.apiUrl + `TeamRequest/`;
  
  constructor(private _httpClient: HttpClient) { }

 /**
   *  gets the types of the TeamRequest
   */
  public getTypes(): Observable<TeamRequestTypes[]> {

    return this._httpClient
      .get<TeamRequestTypes[]>(this.Api_URL + `types`);
  }


  /**
  *  gets the organisationUnits
  */
  public getOrganisationUnits(): Observable<OrganisationUnit[]> {

    return this._httpClient
      .get<OrganisationUnit[]>(this.Api_URL + `ous`);
  }


  /**
  *  gets the approvalUsers
  */
  public getApprovalUsers(orgaUnitId: number): Observable<ApprovalUser[]> {

    return this._httpClient
      .get<ApprovalUser[]>(this.Api_URL + `approvers?orgaUnitId=` + orgaUnitId);
  }

  /**
 *  gets the users
 */
  public getUsers(): Observable<User[]> {

    return this._httpClient
      .get<User[]>(this.Api_URL + `users`);
  }


  /**
*  gets the users
*/
  public getPlant(): Observable<Plant[]> {

    return this._httpClient
      .get<Plant[]>(this.Api_URL + `plants`);
  }



  /**
*  gets the similar teams
*/
  public getSimilars(teamRequest: TeamRequest): Observable<Team[]> {

    return this._httpClient
      .post<Team[]>(this.Api_URL + `similars`, teamRequest)
  }
  

  /**
   *  saves the request
   */
  public save(team: TeamRequest, simliarT: Team[]): Promise<any> {

    const data = { teamRequest: team, similarTeams: simliarT};

    return new Promise((resolve, reject) => {
      this._httpClient.post(this.Api_URL + `add`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
   *  approves the request and creates the team
   */
  public approve(teamRequestId): Promise<any> {

    //const data = { teamRequestId: teamRequestId};

    return new Promise((resolve, reject) => {
      this._httpClient.put(this.Api_URL + `approve?teamRequestId=` + teamRequestId, null)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  /**
  *  denies the request
  */
  public deny(teamRequestId): Promise<any> {

    //const data = { teamRequestId: teamRequestId};

    return new Promise((resolve, reject) => {
      this._httpClient.put(this.Api_URL + `deny?teamRequestId=` + teamRequestId, null)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
  *  gets the teamRequests to approve
  */
  public getToApprove(ouResponibleEmail: string, isShowAllChecked: boolean): Observable<TeamRequest[]> {

    return this._httpClient
      .get<TeamRequest[]>(this.Api_URL + `toApprove?ouResponibleEmail=` + ouResponibleEmail + '&isShowAllChecked=' + isShowAllChecked);
  }

  /**
*  gets the mine teamRequests
*/
  public getMine(creatorEmail: string): Observable<TeamRequest[]> {

    return this._httpClient
      .get<TeamRequest[]>(this.Api_URL + `mine?creatorEmail=` + creatorEmail);
  }

}
